import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-incident-list__event as-d-flex as-align-items-center" }
const _hoisted_2 = { class: "as-incident-list__event-time as-d-flex as-align-items-center" }
const _hoisted_3 = { class: "as-incident-list__event-score as-d-flex as-flex-1" }
const _hoisted_4 = { class: "as-score-home" }
const _hoisted_5 = { class: "as-score-away" }
const _hoisted_6 = { class: "as-incident-list__event-icon as-d-flex justify-content-center as-align-items-center" }
const _hoisted_7 = { class: "as-icon" }
const _hoisted_8 = { class: "as-incident-list__player as-d-flex as-flex-1" }

import IBall from '~src/components/icons/incident/IBall.vue';
    import PlayerItem from '~src/components/foot_stats/final_score/PlayerItem.vue';
    import type { IGoalDetails } from '~src/interfaces/footystats';

    
const __default__ = {};

interface Props{
        modeTeam?: string,
        goal: IGoalDetails
    }
    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IncidentsItem',
  props: {
    modeTeam: { default: 'home' },
    goal: {}
  },
  setup(__props: any) {

    


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.goal.time) + "'", 1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`as-incident-list__event-detail as-d-flex as-flex-1 as-incident-list__event--${_ctx.modeTeam}`)
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", null, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.goal.point?.home), 1),
          _cache[0] || (_cache[0] = _createTextVNode(" - ")),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.goal.point?.away), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(IBall)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(PlayerItem, {
          name: _ctx.goal?.player?.full_name ?? _ctx.goal?.player?.first_name,
          img: _ctx.getImgUrlBySport('player', _ctx.goal?.player ? _ctx.goal.player?.id.toString() : 'default')
        }, null, 8, ["name", "img"])
      ])
    ], 2)
  ]))
}
}

})